import SparkMD5 from "spark-md5"

export const resolveFile = fileInfo => {
  return new Promise((resolve, reject) => {
    const file = fileInfo.file
    let fileReader = new FileReader()
    let time = new Date().getTime()
    let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
    let currentChunk = 0
    const chunkSize = 1 * 1024 * 1024
    let chunks = Math.ceil(file.size / chunkSize)
    let spark = new SparkMD5.ArrayBuffer()
    const fileChunks = []
    loadNext()
    fileReader.onload = e => {
      spark.append(e.target.result)
      if (currentChunk < chunks) {
        currentChunk++
        loadNext()
      } else {
        let md5 = spark.end()
        computeMD5Success(md5, file)
        window.console.log(
          `MD5计算完毕：${file.name} \nMD5：${md5} \n分片：${chunks} 大小:${file.size} 用时：${new Date().getTime() - time} ms`
        )
      }
    }
    fileReader.onerror = function() {
      window.console.error(`文件${file.name}读取出错，请检查该文件`)
      reject(`文件${file.name}读取出错，请检查该文件`)
    }
    function computeMD5Success(md5) {
      const result = {
        identifier: md5,
        fileChunks,
        status: "success",
        ...fileInfo
      }
      resolve(result)
    }
    function loadNext() {
      let start = currentChunk * chunkSize
      start > file.size && (start = file.size)
      let end = start + chunkSize >= file.size ? file.size : start + chunkSize
      if (start !== end) {
        fileChunks.push(blobSlice.call(file, start, end))
      }
      fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
    }
  })
}

export const fileChunkMd5 = fileChunk => {
  return new Promise((resolve, reject) => {
    let fileReader = new FileReader()
    let time = new Date().getTime()
    let spark = new SparkMD5.ArrayBuffer()
    fileReader.readAsArrayBuffer(fileChunk)
    fileReader.onload = e => {
      spark.append(e.target.result)
      let md5 = spark.end()
      window.console.log(`MD5计算完毕: 用时：${new Date().getTime() - time} ms`)
      resolve(md5)
    }
    fileReader.onerror = err => {
      window.console.error(err)
      reject(err)
    }
  })
}
